import mapapalWordmark from '../assets/brand/mapapal-transp.png'

export function DesktopHeaderBrand() {
  return (
    <div className="desktop-header-brand" aria-hidden="true">
      <img src={mapapalWordmark} alt="" />
      <span>Share your real-time location with friends</span>
    </div>
  )
}
